type Ga4ItemIdSource = { webStyleId?: string | number | null; sku?: string | number | null };

/** GA4 `item_id` only: prefer web style id (enriched), else sku. Checkout `item_variant` stays the line SKU — do not mirror this helper there. */
export const getGa4ItemId = (item: Ga4ItemIdSource): string | null => String(item.webStyleId ?? item.sku ?? '') || null;
